var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98081 15.1245C1.60194 15.1245 1.28125 14.9933 1.01875 14.7308C0.75625 14.4683 0.625 14.1476 0.625 13.7687V3.73034C0.625 3.35146 0.75625 3.03077 1.01875 2.76827C1.28125 2.50577 1.60194 2.37452 1.98081 2.37452H3.01919V0.788086H4.17306V2.37452H9.85581V0.788086H10.9808V2.37452H12.0192C12.3981 2.37452 12.7188 2.50577 12.9813 2.76827C13.2438 3.03077 13.375 3.35146 13.375 3.73034V13.7687C13.375 14.1476 13.2438 14.4683 12.9813 14.7308C12.7188 14.9933 12.3981 15.1245 12.0192 15.1245H1.98081ZM1.98081 13.9995H12.0192C12.0769 13.9995 12.1298 13.9755 12.1778 13.9273C12.2259 13.8793 12.25 13.8265 12.25 13.7687V6.73034H1.75V13.7687C1.75 13.8265 1.77406 13.8793 1.82219 13.9273C1.87019 13.9755 1.92306 13.9995 1.98081 13.9995Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4914c1b2bac4ada31cc8fb0209c6021a.svg";
export { ForwardRef as ReactComponent };